import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../../theming/styled-components.js';
import themes from '../../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../../hocs/withDefaultTheme.js';

var _templateObject;
var StyledTabsContainer = /*#__PURE__*/memo(styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""]))));
var TabsContainer = function TabsContainer(_ref) {
  var children = _ref.children,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themes["default"] : _ref$theme;
  return /*#__PURE__*/React.createElement(StyledTabsContainer, {
    theme: theme
  }, children);
};
var TabsContainer$1 = withDefaultTheme(/*#__PURE__*/memo(TabsContainer));

export default TabsContainer$1;
